// removed by extract-text-webpack-plugin
module.exports = {"publicsection":"wmf-3tl5Ne-G","publlictitle":"wmf-A3D8XMZq","required":"wmf-HWa0fgKg","informationtitle":"wmf-cfAd7QtX","titles":"wmf-v1aqBT2D"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/commoditymanagement/commoditydetails/completeinformationdetails/medicalequipmentnhaitaodetails/medical-equipmentn-haitao.module.less
// module id = 618
// module chunks = 0